// typings

import { create } from "zustand";

import { IExpedicaoState } from "@/store-zustand/expedition/index";

// criação da store com Zustand (Expedições)
export const useStoreZustandExpedicoes = create<IExpedicaoState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  downloadLoad: [],
  minhasTarefas: [],
  expedicoes: [1],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  remessa: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setExpedicoes: (expedicoes) => set({ expedicoes }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setRemessa: (remessa) => set({ remessa }),
}));
